import firebase, { firestore } from "firebase";

// export const app = firebase.initializeApp(environment.firebase);
// firebase.functions().useFunctionsEmulator("http://127.0.0.1:5001");
const functions = firebase.app().functions();
export const initCustomer = functions.httpsCallable("initCustomerV2");
export const createPaymentSource = functions.httpsCallable("createPaymentSourceV2");
export const createSubscription = functions.httpsCallable("createSubscriptionV2");

export const getBit = functions.httpsCallable("getBitV2");
export const getBits = functions.httpsCallable("getBitsV2");
export const getLibrary = functions.httpsCallable("getLibraryV2");
export const getLibraries = functions.httpsCallable("getLibrariesV2");
export const getUserChapter = functions.httpsCallable("getUserChapterV2");
export const getUserChapters = functions.httpsCallable("getUserChaptersV2");
export const getUserBook = functions.httpsCallable("getUserBookV2");
export const getUserBooks = functions.httpsCallable("getUserBooksV2");
export const getUserCollection = functions.httpsCallable("getUserCollectionV2");
export const getUserCollections = functions.httpsCallable("getUserCollectionsV2");
export const getPopular = functions.httpsCallable("getPopularV2");
export const searchByTerm = functions.httpsCallable("searchByTermV2");

export const getVolumeChaptersRef = functions.httpsCallable("getVolumeChaptersRefV2");
export const getUserProfile = functions.httpsCallable("getUserProfileV2");
export const reactivateSubscription = functions.httpsCallable("reactivateSubscriptionV2");

export const subscribe = functions.httpsCallable("subscribeV2");
export const getLinkCount = functions.httpsCallable("getLinkCountV2");

export const getLatestUpdates = functions.httpsCallable("getLatestUpdatesV2");
export const saveUserContent = functions.httpsCallable("saveUserContentV2");
export const setPromoCode = functions.httpsCallable("setPromoCodeV2");
export const addToCollectionList = functions.httpsCallable("addToCollectionListV2");
export const removeFromCollectionList = functions.httpsCallable("removeFromCollectionListV2");
export const getUserOptions = functions.httpsCallable("getUserOptionsV2");
export const addNote = functions.httpsCallable("addNoteV2");
export const addToBookList = functions.httpsCallable("addToBookListV2");
export const removeFromBookList = functions.httpsCallable("removeFromBookListV2");
export const addToChapterList = functions.httpsCallable("addToChapterListV2");
export const removeFromChapterList = functions.httpsCallable("removeFromChapterListV2");
export const addView = functions.httpsCallable("addViewV2");
export const addReview = functions.httpsCallable("addReviewV2");
export const deleteReview = functions.httpsCallable("deleteReviewV2");
export const getPrevReview = functions.httpsCallable("getPrevReviewV2");
export const uploadCollectionFromBits = functions.httpsCallable("uploadCollectionFromBitsV2");
export const createConnectedAccountOnboardingLink = functions.httpsCallable("createConnectedAccountOnboardingLinkV2");
export const createConnectedAccountDashboardLink = functions.httpsCallable("createConnectedAccountDashboardLinkV2");
export const doesPhoneExist = functions.httpsCallable("doesPhoneExistV2");
export const getAuthMethods = functions.httpsCallable("getAuthMethods");

export const createPortalLink = functions.httpsCallable("createPortalLinkV2");
export const deleteSubscription = functions.httpsCallable("deleteSubscriptionV2");
export const createStripeCustomer = functions.httpsCallable("createStripeCustomerV2");

export const isSubscribed = functions.httpsCallable("isSubscribed");
export const getSubscribedContent = functions.httpsCallable("getSubscribedContent");

export async function getBackendData(
  path: string,
  where: (any | any[])[][],
  values: string[]
): Promise<firestore.DocumentData | firestore.DocumentData[]> {
  const data = await functions.httpsCallable("getBackendDataV2")({ path: path, where: where, values: values });
  console.log("Data from getBackendData:", data);
  if (data.data?.arr || JSON.stringify(data?.data?.arr) == "{}") {
    return data.data.arr ?? [];
  }
  return data.data;
}
export async function setBackendData(path: string = "", operation: "update" | "set" | "delete", data: Object): Promise<boolean> {
  return functions
    .httpsCallable("setBackendDataV2")({
      path: path,
      operation: operation,
      data: data,
    })
    .then((res) => {
      if (res.data) {
        return res.data;
      }

      return false;
    })
    .catch((err) => {
      console.error("Error in setdata", err);
      return false;
    });
}
